import { c as _c } from "react/compiler-runtime";
import { promotionCategoryBadgeClassName } from "../../promotion-category";
import { cx } from "@/lib/tailwind-utils";
interface PromotionBadgeProps {
  promotionName: string;
}
export const PromotionBadge = t0 => {
  const $ = _c(3);
  const {
    promotionName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cx(promotionCategoryBadgeClassName, "shrink-0 px-1.5 py-0.5 text-tiny");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== promotionName) {
    t2 = <span className={t1}>{promotionName}</span>;
    $[1] = promotionName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};